"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductDrivers = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.array.map.js");
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _apollo = require("@nerdwallet/apollo");
var _drivers = require("@nerdwallet/marketplace/constants/drivers");
var _reactQuickFacts = require("@nerdwallet/react-quick-facts");
var _nwAuthTools = require("../lib/utils/nw-auth-tools");
var _utils = require("../lib/utils");
var _constants = require("../lib/constants");
var _render = require("../lib/utils/render");
var _likelihoodOfApprovalCta = _interopRequireDefault(require("../likelihood-of-approval-cta"));
var _baseDrivers = _interopRequireDefault(require("./base-drivers"));
var _CreditScoreWidget = require("../creditscore_pill/CreditScoreWidget");
var _templateObject;
var ProductDrivers = function ProductDrivers(_ref) {
  var _placementDrivers;
  var analytics = _ref.analytics,
    approvalOddsEnabled = _ref.approvalOddsEnabled,
    className = _ref.className,
    _ref$driversRenderer = _ref.driversRenderer,
    driversRenderer = _ref$driversRenderer === void 0 ? _render.defaultRenderer : _ref$driversRenderer,
    identity = _ref.identity,
    gqlMarketplaceEntity = _ref.gqlMarketplaceEntity,
    placementDrivers = _ref.placementDrivers,
    shouldShowMatchScoreCta = _ref.shouldShowMatchScoreCta,
    shouldShowNAValues = _ref.shouldShowNAValues,
    shouldOmitCreditScoreDriver = _ref.shouldOmitCreditScoreDriver,
    horizontalMobileDrivers = _ref.horizontalMobileDrivers,
    showCreditScorePill = _ref.showCreditScorePill;
  var _ref2 = gqlMarketplaceEntity,
    maxFico = _ref2.maxFico,
    minFico = _ref2.minFico,
    recommendedCreditScoreRangeDetails = _ref2.recommendedCreditScoreRangeDetails,
    limitedCreditHistory = _ref2.limitedCreditHistory;
  var drivers = placementDrivers !== null && placementDrivers !== void 0 ? placementDrivers : gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_placementDrivers = gqlMarketplaceEntity.placementDrivers) === null || _placementDrivers === void 0 ? void 0 : _placementDrivers.map(function (driver) {
    return (0, _render.normalizeEntityPlacementDriver)(driver, driversRenderer);
  });
  if ((0, _isEmpty2.default)(drivers)) {
    return null;
  }
  var quickFacts = drivers;

  /* eslint-disable no-underscore-dangle */
  if ((gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.__typename) === 'CreditCardsOfferV2' && !shouldOmitCreditScoreDriver) {
    /* eslint-enable no-underscore-dangle */
    var creditScoreRange = recommendedCreditScoreRangeDetails.creditScoreRange,
      creditScoreRangeDescription = recommendedCreditScoreRangeDetails.description;
    if (shouldShowMatchScoreCta) {
      if (minFico && maxFico) {
        quickFacts.push({
          id: 'recommendedCreditScoreRange',
          label: 'Rec Credit Score',
          value: creditScoreRange || null,
          valueSize: _drivers.VALUE_SIZES.MEDIUM,
          description: creditScoreRangeDescription
        });
      }
    } else {
      /**
       * taken from @link {https://github.com/NerdWallet/react-components/blob/005135a36bf9ee3edd37e24351bd3d830c671174/components/marketplace-product-card/src/mappings/credit-cards.jsx#L74}
       * and from @link {https://github.com/NerdWallet/react-components/blob/753ec5f0b3813999ab8fd8e091cb91c35ccbdd8f/components/quick-facts/src/mappings/credit-cards.jsx#L111}
       * to get the same mapping logic but using graphql.
       * @todo move this likelyhood of approval logic to structured-content
       * @link {https://nerdwallet.atlassian.net/browse/RUR-192}
       */
      var tooltipContent = (0, _utils.getLoaTooltipContent)(identity);
      var creditScore = (0, _nwAuthTools.getCreditScore)(identity);
      var ctaComponent = /*#__PURE__*/_react.default.createElement(_likelihoodOfApprovalCta.default, {
        approvalOddsEnabled: approvalOddsEnabled,
        analytics: analytics === null || analytics === void 0 ? void 0 : analytics.loaCtaProps,
        ctaText: approvalOddsEnabled ? _constants.SEE_YOUR_APPROVAL_ODDS : _constants.GET_YOUR_FREE_CREDIT_SCORE,
        enableAnalytics: true,
        tooltipLabel: !(0, _isEmpty2.default)(tooltipContent) ? _constants.LOA_CTA_TOOLTIP_LABEL : null,
        tooltipContent: tooltipContent,
        isKetoCard: horizontalMobileDrivers
      });
      var label;
      var loaWidget;
      if (showCreditScorePill && !creditScore) {
        label = /*#__PURE__*/_react.default.createElement(_CreditScoreWidget.CreditScoreWidgetLabel, null);
        loaWidget = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_CreditScoreWidget.CreditScoreWidget, {
          minFico: minFico,
          maxFico: maxFico,
          limitedCreditHistory: limitedCreditHistory,
          analytics: analytics === null || analytics === void 0 ? void 0 : analytics.loaCtaProps
        }), ctaComponent);
      }
      if (!quickFacts.some(function (x) {
        return x.id === 'likelihoodOfApproval';
      }) && loaWidget) {
        quickFacts.push({
          /** @ts-ignore  structured content type does not allow for a component as a label */
          label: label,
          id: 'likelihoodOfApproval',
          /** @ts-ignore structured content type did not allow for a component as a value */
          value: !(0, _isEmpty2.default)(gqlMarketplaceEntity) ? loaWidget : null,
          valueFormat: _reactQuickFacts.FORMATS.UNFORMATTED,
          wide: true
        });
      }
    }
  }
  if ((gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.productType) === 'banking' && shouldShowNAValues) {
    quickFacts.forEach(function (fact) {
      if (!fact.value) {
        fact.value = 'N/A'; /* eslint-disable-line no-param-reassign */
      }
    });
  }

  return /*#__PURE__*/_react.default.createElement(_baseDrivers.default, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.driversProps,
    className: className,
    drivers: quickFacts,
    horizontalMobileDrivers: horizontalMobileDrivers
  });
};
exports.ProductDrivers = ProductDrivers;
ProductDrivers.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment GqlProductDrivers on MarketplaceEntityInterface {\n    __typename\n    ... on MarketplaceEntityWithPlacementInterface {\n      placementDrivers {\n        ...normalizeEntityPlacementDriver\n      }\n    }\n    ... on CreditCardsOfferV2 {\n      legacyId\n      maxFico\n      minFico\n      recommendedCreditScoreRangeDetails {\n        creditScoreRange\n        description\n      }\n      slug\n    }\n  }\n  ", "\n"])), _render.normalizeEntityPlacementDriver.fragment);